/*
Aditya 09/26/2022  3075154998  Changed DM label to Data mananger
Dilip  10/11/2022  3075154998  Data Manager Matching logic changes
Akhila  10/28/2022 3075154998 data manager ux changes
  */
import React, {useState, useContext} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import {Card} from '@material-ui/core';
import DmrecordSearch from './SearchDmRecords/SearchDMRecords';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import AddDmRecordsForm from './AddFilter/AddDmRecords';

const useStyles = makeStyles((theme) => ({
  'root': {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  'padding': {
    padding: '40px',
  },
  'MuiTabScrollButton-root': {
    color: 'black',
  },
  'demo1': {
    color: 'white',
    borderRadius: '6px',
  },
  'searchRuleButton': {
    margin: '-8px 0 8px',
  },
  'cardStyles': {
    backgroundColor: '#FFF',
    padding: '15px',
    marginBottom: 10,
    borderRadius: 8,
  },
}));

export default function DmRecordsSubTabs() {
  const classes = useStyles();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes1 = reusableInputStyles();
  const [tabValue, setTabValue] = useState(0);
  return (
    <Card className={` ${classes1.cardBordernoneStyles} mb-0`} elevation={0}>
      <div className={classes.root}>
        {/* <AntTabs
          className={classes.demo1}
          value={tabValue}
          onChange={handleChange}
          aria-label="ant example"
          variant="scrollable"
          scrollButtons="auto"
        >
          <AntTab label="Search Records" />
          <AntTab label="Add Records" />
        </AntTabs> */}
        <Typography />
        <div className={classes.subContent}>
          {tabValue === 0 && (
            <DmrecordSearch
              setTabValue={setTabValue}
            //   setCode={setCode}
            //   mediaName={mediaName}
            //   setMediaName={setMediaName}
            //   setIsCopyData={setIsCopyData}
            //   setUsageState={setUsageState}
            //   usageState={usageState}
            />
          )}
          {tabValue === 1 && (
            <AddDmRecordsForm
              setTabValue={setTabValue}
            //   setCode={setCode}
            //   code={code}
            //   mediaName={mediaName}
            //   setMediaName={setMediaName}
            //   isCopyData={isCopyData}
            //   setUsageState={setUsageState}
            />
          )}
          {/* {tabValue === 2 && (
            <MediaUsage setUsageState={setUsageState}/>
          )} */}
        </div>
      </div>
    </Card>
  );
}
